module.exports = __webpack_public_path__ + "static/media/38-2.e968f05a.mp3";